<template>
  <div class="footer" :class="className">
    <div class="wrap">
      <div class="footer-main">
        <!-- Left: 公司信息 -->
        <div class="footer-col">
          <h4>关于我们</h4>
          <p>济南鲁凝教育咨询服务有限公司</p>
          <p>地址：山东省济南市历下区仁恒世纪花园2号楼101</p>
          <p class="footer-copy">&copy; 2025 山东省二级建造师继续教育平台. All rights reserved.</p>
          <p class="footer-icp"><a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2025188245号-1</a></p>
          <p class="footer-browser">建议使用 Chrome、Edge、Firefox 等主流浏览器</p>
        </div>

        <!-- Center: 快捷方式 -->
        <div class="footer-col">
          <h4>快捷方式</h4>
          <div class="footer-links">
            <span @click="$router.push('/')">网站首页</span>
            <span @click="$router.push('/mySubject')">我的课程</span>
            <span @click="$router.push('/noticeList')">通知公告</span>
            <span @click="goProfile">个人中心</span>
          </div>
        </div>

        <!-- Right: 公众号 & 小程序 -->
        <div class="footer-col">
          <h4>关注我们</h4>
          <div class="qr-codes">
            <div class="qr-code">
              <i class="el-icon-office-building"></i>
              <span>企业公众号</span>
            </div>
            <div class="qr-code">
              <i class="el-icon-mobile-phone"></i>
              <span>小程序</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data() {
    return {
      className: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.isAbsolute();
      }, 500);
    });
  },
  methods: {
    goProfile() {
      let routeData = this.$router.resolve({ name: "profile" });
      window.open(routeData.href, "_blank");
    },
    isAbsolute() {
      const parentHeight = document.querySelector("#app").offsetHeight;
      const viewportHeight = window.innerHeight;
      if (viewportHeight > parentHeight) {
        this.className = "absolute";
      } else {
        this.className = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  background: linear-gradient(180deg, #1e293b, #0f172a);
  padding: 40px 20px 0;
  margin-top: 40px;

  .wrap {
    max-width: 1100px;
    margin: 0 auto;
  }

  .footer-main {
    display: flex;
    gap: 40px;
    padding-bottom: 32px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .footer-col {
    h4 {
      color: #e2e8f0;
      font-size: 15px;
      font-weight: 600;
      margin: 0 0 16px;
      padding-bottom: 10px;
      border-bottom: 2px solid #64B5F6;
      display: inline-block;
    }

    p {
      margin: 0;
      font-size: 13px;
      color: #a0aec0;
      line-height: 2;
    }

    .footer-copy {
      margin-top: 12px;
      font-size: 12px;
      color: #718096;
      line-height: 1.8;
    }

    .footer-icp {
      font-size: 12px;
      color: #718096;
      line-height: 1.8;

      a {
        color: #718096;
        text-decoration: none;
        &:hover { color: #64B5F6; }
      }
    }

    .footer-browser {
      font-size: 12px;
      color: #718096;
      line-height: 1.8;
    }

    &:nth-child(1) { flex: 1.3; }
    &:nth-child(2) { flex: 1; display: flex; flex-direction: column; align-items: center; }
    &:nth-child(3) { flex: 1; display: flex; flex-direction: column; align-items: center; }
  }

  .qr-codes {
    display: flex;
    gap: 16px;
  }

  .footer-links {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px 24px;

    span {
      font-size: 13px;
      color: #a0aec0;
      cursor: pointer;
      line-height: 2.2;
      &:hover { color: #64B5F6; }
    }
  }

  .qr-code {
    width: 100px;
    height: 110px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px dashed rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #a0aec0;
    font-size: 12px;

    i { font-size: 28px; color: #64B5F6; }
  }
}

.absolute {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}

@media (max-width: 768px) {
  .footer .footer-main {
    flex-direction: column;
    gap: 24px;
  }
  .footer .footer-col:nth-child(2),
  .footer .footer-col:nth-child(3) {
    align-items: flex-start;
  }
}
</style>
